module.exports = __webpack_public_path__ + "img/lock-error.23afd060.svg";